<template>
  <hr class="my-8 h-px border-0 bg-gray-200 dark:bg-gray-700" />
</template>
